export default __webpack_public_path__ + "static/ERIN-Logo-e946fabed0c055443299639847d493ba.png";